import { FriendRequestsState, FRIEND_REQUESTS_INIT_STATE } from './friendRequests.state';
import {
    FriendRequestsAction,
    FriendRequestsActionType,
    LoadFriendRequestsFailedAction,
    LoadFriendRequestsSucceededAction
} from './friendRequests.actions';

export function friendRequestsReducer(
    state: FriendRequestsState = FRIEND_REQUESTS_INIT_STATE,
    action: FriendRequestsAction
): FriendRequestsState {
    switch (action.type) {
        case FriendRequestsActionType.LOAD_FRIEND_REQUESTS: {
            return {
                ...state,
                isReady: false,
                invitations: [],
                error: null
            };
        }
        case FriendRequestsActionType.LOAD_FRIEND_REQUESTS_FAILED: {
            return {
                ...state,
                isReady: true,
                invitations: [],
                error: ( < LoadFriendRequestsFailedAction > action.error)
            };
        }
        case FriendRequestsActionType.LOAD_FRIEND_REQUESTS_SUCCEEDED: {
            return {
                ...state,
                isReady: true,
                invitations: ( < LoadFriendRequestsSucceededAction > action).invitations,
                error: null
            };
        }
        case FriendRequestsActionType.ACCEPT_FRIEND_REQUEST_SUCCEEDED: {
            const nextState = JSON.parse(JSON.stringify(state));
            // Remove accepted request from invitations
            for (let i = 0; i < nextState.invitations.length; i++) {
                if (nextState.invitations[i].uid === action.userID) {
                    nextState.invitations.splice(i, 1);
                    break;
                }
            }
            return nextState;
        }
        case FriendRequestsActionType.DENY_FRIEND_REQUEST_SUCCEEDED: {
            const nextState = JSON.parse(JSON.stringify(state));
            // Remove denied request from invitations
            for (let i = 0; i < nextState.invitations.length; i++) {
                if (nextState.invitations[i].uid === action.userID) {
                    nextState.invitations.splice(i, 1);
                    break;
                }
            }
            return nextState;
        }
        default:
            return state;
    }
}
